<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown"
        >
            <template #cell(buttons)="row">
                <b-dropdown variant="link btn-sm" boundary="window" no-caret class="compact-dropdown">
                    <template #button-content>
                        <i class="ri-more-fill text-muted" style="font-size: 1.2rem;"></i>
                    </template>
                    <b-dropdown-item @click="downloadCourseAgreementForm()" v-if="row.item.status_code === 'wdc_approved'">
                        <i class="ri-file-download-line align-middle mr-2 text-muted"></i>
                        {{ $t('download') }}
                    </b-dropdown-item>

                    <b-dropdown-item @click="()=>$router.push('/course/agreement-form')">
                        <i class="ri-eye-line align-middle mr-2 text-muted"></i>
                        {{ $t('detail') }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>
            <template #cell(status)="row">
                <div style="text-align: center">{{ row.item.status }}</div>
                <router-link class="d-flex flex-column" style="gap:4px" to="/epayment" tag="div">
                    <b-button variant="primary" style="line-height: 1" v-if="row.item.status === 'Ödeme Bekliyor'">
                        {{ $t('make_payment') }}
                    </b-button>
                </router-link>
            </template>
        </b-table>
    </div>
</template>

<script>
import DocumentRequestService from "@/services/DocumentRequestService";
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";

/**
 * Course Agreement Tab Component
 */
export default {
    name: 'CourseAgreementTab',
    data() {
        return {
            items: [],
            fields: [
                { key: 'buttons', label: '', thStyle: { width: '50px' }, tdClass: 'text-center' },
                { key: 'academic_year', label: this.$t('academic_year') },
                { key: 'semester', label: this.$t('semester') },
                { key: 'program', label: this.$t('program_name') },
                { key: 'reason', label: this.$t('reason') },
                { key: 'status', label: this.$t('status') },
            ],
        };
    },
    methods: {
        fetchData() {
            DocumentRequestService.getStudentRequests()
                .then(response => {
                    this.items = [];
                    Object.keys(response.data.data).forEach(key => {
                        let item = response.data.data[key];
                        this.items.push({
                            semester: item.semester,
                            academic_year: item.academic_year,
                            program: this.getLocaleText(item, 'program_name'),
                            status: this.getLocaleText(item, 'status_name'),
                            status_code: item.status,
                            reason: item.reason,
                            id: item.id,
                        });
                    });
                })
                .catch(err => this.showErrors(err));
        },
        downloadCourseAgreementForm() {
            CourseAgreementFormServices.downloadForm()
                .then(response => {
                    this._downloadFile(response, 'course_agreement.pdf');
                })
                .catch(e => {
                    this.$toast.error(this.$t('api.' + (e.data?.message || 'error')));
                });
        }
    },
    created() {
        this.fetchData();
    }
};
</script>

<style scoped>
.compact-dropdown >>> .dropdown-toggle {
    padding: 0;
    line-height: 1;
}
</style>
